import { Link } from 'react-router-dom';
import { genres } from '@/mocks/genres';
import NewsletterForm from './NewsletterForm';

const friendLinks = [
  { label: 'KBS 韩国放送公社', href: 'https://kz68.cn' },
  { label: 'tvN 官方频道', href: 'https://tvn.cjenm.com' },
  { label: 'JTBC 官方网站', href: 'https://jtbc.joins.com' },
  { label: 'Netflix 韩国影视', href: 'https://www.netflix.com' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="w-10 h-10 rounded-lg bg-white text-primary-700 flex items-center justify-center font-heading font-bold text-xl">
                韩
              </span>
              <span className="font-heading font-bold text-2xl text-white">韩剧</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-primary-100/80">
              专注最新韩剧剧集展示与剧情资讯，为韩剧爱好者提供分类浏览、剧情介绍、演员资料与热点资讯的一站式追剧体验。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wider text-white uppercase mb-4">题材导航</h3>
            <ul className="grid grid-cols-2 gap-y-2.5 gap-x-4">
              {genres.slice(0, 8).map((g) => (
                <li key={g.key}>
                  <Link to={`/category/${g.key}`} className="text-sm text-primary-100/80 hover:text-white transition-colors cursor-pointer">
                    {g.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wider text-white uppercase mb-4">网站导航</h3>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-primary-100/80 hover:text-white transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/news" className="text-sm text-primary-100/80 hover:text-white transition-colors cursor-pointer">资讯专题</Link></li>
              <li><Link to="/search" className="text-sm text-primary-100/80 hover:text-white transition-colors cursor-pointer">搜索剧集</Link></li>
              <li><Link to="/about" className="text-sm text-primary-100/80 hover:text-white transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wider text-white uppercase mb-4">订阅追剧资讯</h3>
            <p className="text-sm text-primary-100/80 mb-3">订阅后，第一时间收到最新上线的韩剧与热点资讯。</p>
            <NewsletterForm />
            <div className="mt-5 space-y-2 text-sm text-primary-100/80">
              <p className="flex items-center gap-2"><i className="ri-mail-line"></i> service@hanju.example</p>
              <p className="flex items-center gap-2"><i className="ri-map-pin-line"></i> 韩国首尔特别市麻浦区上岩洞</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-primary-100/70">© 2026 韩剧（hanju.example）版权所有 · 本站内容仅供浏览与资讯展示，不提供任何播放与下载服务</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            {friendLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-xs text-primary-100/70 hover:text-white transition-colors cursor-pointer"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}